import React, { useState } from 'react';
import AliceCarousel, { EventObject, Responsive } from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import './gallery.css';

interface Props {
    title?: string;
    titleIcon?: string;
    marginTop?: number;
    marginBottom?: number;
    responsive?: Responsive;
    items: JSX.Element[];
}

const Gallery: React.FC<Props> = ({
    title,
    titleIcon,
    marginTop,
    marginBottom,
    responsive,
    items,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleSlideChanged = (e: EventObject) => {
        setCurrentIndex(e.item);
    };

    return (
        <>
            <div
                style={{
                    marginTop: marginTop ? marginTop + 'px' : '0px',
                    marginBottom: marginBottom ? marginBottom + 'px' : '0px',
                }}
            >
                {titleIcon && title && (
                    <h3>
                        {' '}
                        <i
                            className={`${titleIcon}`}
                            style={{ color: '#515151' }}
                        />{' '}
                        {title}
                    </h3>
                )}
                <AliceCarousel
                    responsive={responsive}
                    disableDotsControls={true}
                    infinite={false}
                    onSlideChanged={handleSlideChanged}
                    items={items}
                />
            </div>
        </>
    );
};

export default Gallery;
